<img alt="{{ alt }}" src="{{ src }}" />
